import { ReactNode } from "react";
import { Referentiel } from "../../referentiel";
import { Establishment } from "../../ClientSpace";
import { AuthUser } from "../../Auth";

export type DossierDataToUpdate = {
    completionTime?: string;
    processingStep?: number;
    establishmentStatus?: number | null;
    dossierStatus?: number | null;
    submittedAt?: string | null;
    submittedUser?: number | null;
    assignerUser?: number | null;
    assignedUser?: number | null;
    assignedAt?: string;
    processedAt?: string;
    assignedComment?: string | null;
    // synerpa
    assignedValidatorUser?: number | null;
    assignedValidatorComment?: string | null;
    payment?: boolean;
    assignedValidatorDecisionAt?: string | null;
    assignedUserOpinion?: boolean;
};

export type Dossier = {
    id: number | null;
    completionTime: string;
    processingStep: number;
    createdAt: string;
    assignedAt: string;
    processedAt: string;
    certificationUrl: string;
    contractUrl?: string;
    assignedUser: number | null;
    assignedValidatorUser: number | null;
    assignerUser: number | null;
    creatorUser: number | null;
    dossierStatus: number | null;
    establishment: number | null;
    establishmentStatus: number | null;
    referenciel: number | null;
    submittedAt: string | null;
    assignedComment?: string;
    assignedValidatorComment?: string;
    payment?: boolean;
    assignedValidatorDecisionAt?: string | null;
    assignedUserOpinion?: boolean;
    commitmentsCompleted: number;
};

export type Document = {
    id: number;
    name: string;
    url: string;
    commitmentRequirement: number;
    establishementType: number;
    dossier: number | null;
    year: number | undefined;
    comment: string | null;
    compliant: boolean | null;
    type?: string;
};

export type DocumentToUploadType = Omit<
    Document,
    | "id"
    | "url"
    | "year"
    | "commitmentRequirement"
    | "dossier"
    | "establishementType"
    | "compliant"
> & {
    id?: number;
    file: any;
    year_id: number | undefined;
    commitment_requirement_id: number;
    dossier_id: number | null;
    establishment_type_id: number;
    compliant?: false | true | null;
    document_id?: number;
};

export type CommitmentRequirement = {
    id: number;
    name: string;
    commitment: number;
    position: number;
    documentQty: number;
    establishmentType: number;
    libraryDocument?: number;
    documentaryProof: string;
};

export type Commitment = {
    id: number | null;
    name: string;
    objective: string;
    position: number;
    referenciel: string;
};

export type CommitmentRequirementDetails = CommitmentRequirement & {
    documents: Document[];
};

export type DossierDetail = Commitment & {
    commitmentRequirements: CommitmentRequirementDetails[];
};

export type dossierStatusColorsType = {
    border?: string;
    background?: string;
    status?: string;
};

export type InstitutionalAffiliationType = {
    network?: string;
    region?: string;
};

export type OverViewDossierType = {
    alertText?: string;
    status?: string;
    dossierId?: number | null;
    title?: string;
    subTitle?: string;
    content?: ReactNode;
    statusCode?: string;
    infoSubmitting?: {
        date: string;
        processingStep: number;
    };
    showDownloadCertificateBtn?: boolean;
    actions?: {
        edit?: ReactNode;
        downloadCertificate?: Function;
    };
    _dossierStatusColors?: dossierStatusColorsType;
    onPaymentClick?: Function;
    isPayed?: boolean;
    disablePaymentBtn?: boolean;
    hidePaymentBtn?: boolean;
    commitmentsCompleted?: number | null;
    institutionalAffiliation?: InstitutionalAffiliationType;
};

export type CommitementDetails = Commitment & {
    commitmentRequirements: CommitmentRequirementDetails[];
};

export type DossierDetailType = Omit<
    Dossier,
    "referenciel" | "dossierStatus" | "establishment" | "assignedValidatorUser"
> & {
    assignedValidatorUser?: AuthUser | null;
    dossierStatus: DossierStatus;
    referenciel: Referentiel & {
        commitments: CommitementDetails[];
    };
    establishment: { id: number } & Establishment;
    instructionDeadlineAt: string;
};

export enum DossierStatusEnum {
    CREATION = "COMPLETUDE",
    SOUMIS = "SOUMIS",
    AFFECTE = "AFFECTE",
    EN_COURS_D_INSTRUCTION = "EN_COURS_D_INSTRUCTION",
    ATTENTE_REGLEMENT = "ATTENTE_REGLEMENT",
    ATTENTE_DECISION = "ATTENTE_DECISION",
    FINALISE = "FINALISE",
}

export enum establishementStatusEnum {
    CANDIDAT = "CANDIDAT",
    QUALIFIE = "QUALIFIE",
    NON_QUALIFIE = "NON_QUALIFIE",
    RETIRE = "RETIRE",
    ATTENTE_DECISION = "ATTENTE_DECISION",
    SUSPENDU = "SUSPENDU",
    ANNULE = "ANNULE",
}

export type DossierStatus = {
    id: number;
    label: string;
    code: string;
};

export type EstablishmentStatus = {
    id: number;
    label: string;
    code: string;
};

export type GroupedDossierList = {
    [key: number]: DossierDetailType[];
};

export type EstablishmentDbType = Establishment & { id: number };

export type contractInfosToUploadType = {
    dossier_id: number;
    file: any;
};

export * from "./DossierCreation";
